import { render, staticRenderFns } from "./RegisterCompanyValidate.vue?vue&type=template&id=332ebc6f&"
import script from "./RegisterCompanyValidate.vue?vue&type=script&lang=ts&"
export * from "./RegisterCompanyValidate.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCompanyValidate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports